<div class="bgColorWhite body-scroll">
  @if (showData) {
<div class="text-center boldText"><h3>{{pageTitle}}</h3></div>
}
  @if (loading) {
<div class="formLoader"><i class="fa fa-spinner fa-spin gt-refresh"></i></div>
}
  @if (!loading && hoveringDeficitsData.length) {
<div class="col-md-12 boldText" style="width:100%;">
    <table class="table nowrap table-bordered table-condensed table-hover table-striped boldText custom-table">
      <thead><tr>@for (columnName of columnNames; track $index) {
<th nowrap>{{columnName}}</th>
}</tr></thead>
      <tbody>
      @for (row of hoveringDeficitsData; track $index) {
<tr>
        @for (columnName of columnNames; track $index) {
<td nowrap [ngClass]="columnName !== 'DESCRIPTION' ? 'rightAlign' : ''">
          {{columnName !== 'DESCRIPTION' ? (row[columnName] | number) : row[columnName]}}
        </td>
}
      </tr>
}
      </tbody>
    </table>
  </div>
}
</div>
